module.exports = __webpack_public_path__ + "img/file-earmark-break-fill.f0f0d631.svg";